<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Notification Type"
      text="Edit Notification Type"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localNotificationType.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>
            <v-col
              cols="12"
              class="font-weight-black"
            >
              <div>
                <span>Is Active?</span>
                <v-radio-group
                  v-model="localNotificationType.is_active"
                  row
                >
                  <v-radio
                    label="No"
                    :value="0"
                  />
                  <v-radio
                    label="Yes"
                    :value="1"
                  />
                </v-radio-group>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="px-10 white--text"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      notificationType: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localNotificationType: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localNotificationType = { ...this.notificationType }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.$api.notificationTypes().update(this.notificationType.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
   
      prepareFormData () {
        return {
          name: this.localNotificationType.name,
          is_active: this.localNotificationType.is_active,
        }
      },
    },
  }
</script>
